module.exports = __webpack_public_path__ + "static/media/msg-offline.78bdb26f.svg";